import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { getForcedGlobalClassnamesForContext, getComponentName, } from './helpers';
import { ThemeOptions, ThemeSkin } from './constants';
export var ThemeContext = React.createContext(undefined);
ThemeContext.displayName = 'ThemeContext';
export var ThemeSkinContext = React.createContext(undefined);
ThemeSkinContext.displayName = 'ThemeSkinContext';
export function useSelectByTheme(_a) {
    var dark = _a.dark, light = _a.light, _b = _a.green, green = _b === void 0 ? light : _b;
    var theme = useContext(ThemeContext);
    var themeSkin = useContext(ThemeSkinContext);
    if (theme === ThemeOptions.DARK) {
        return dark;
    }
    if (themeSkin === ThemeSkin.GREEN) {
        return green;
    }
    return light;
}
// HOC for convenience...
export function withThemeContext(Component) {
    var DecoratedComponent = function (props) {
        var theme = useContext(ThemeContext);
        return React.createElement(Component, __assign({ theme: theme }, props));
    };
    DecoratedComponent.displayName = "withThemeContext(".concat(getComponentName(Component), ")");
    return DecoratedComponent;
}
// and for overriding theme...
export var ThemeOverride = function (_a) {
    var children = _a.children, theme = _a.theme, className = _a.className, _b = _a.tag, Tag = _b === void 0 ? 'span' : _b, rest = __rest(_a, ["children", "theme", "className", "tag"]);
    if (theme === 'match') {
        return React.createElement(Tag, { className: className }, children);
    }
    return (React.createElement(ThemeContext.Provider, { value: theme },
        React.createElement(Tag, __assign({ className: classnames(className, getForcedGlobalClassnamesForContext({
                theme: theme,
            })) }, rest), children)));
};
ThemeOverride.displayName = 'ThemeOverride';
export var useReverseTheme = function () {
    var theme = useContext(ThemeContext);
    var flippedTheme = theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT;
    return flippedTheme;
};
export var ReverseTheme = function (_a) {
    var children = _a.children, className = _a.className, tag = _a.tag;
    var flippedTheme = useReverseTheme();
    return (React.createElement(ThemeOverride, { theme: flippedTheme, className: className, tag: tag }, children));
};
ReverseTheme.displayName = 'ReverseTheme';
// re-export to avoid changing a billion imports again...
export { ThemeOptions, ThemeSkin };
//# sourceMappingURL=ThemeContext.js.map